import * as React from 'react';

const CopyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={14}>
    <path
      fill="#fff"
      d="M9.483 13.04H2.371A2.37 2.37 0 0 1 0 10.67V5.336a2.37 2.37 0 0 1 2.37-2.371h7.113a2.37 2.37 0 0 1 2.371 2.37v5.335a2.371 2.371 0 0 1-2.37 2.37ZM2.371 4.15a1.185 1.185 0 0 0-1.186 1.186v5.334a1.185 1.185 0 0 0 1.186 1.185h7.112a1.185 1.185 0 0 0 1.186-1.185V5.336A1.185 1.185 0 0 0 9.483 4.15H2.371Z"
    />
    <path
      fill="#fff"
      d="M13.632 10.076h-6.52a2.37 2.37 0 0 1-2.37-2.37V2.37A2.37 2.37 0 0 1 7.112 0h6.52a2.37 2.37 0 0 1 2.37 2.37v5.335a2.37 2.37 0 0 1-2.37 2.37Zm-6.52-8.89A1.185 1.185 0 0 0 5.927 2.37v5.334a1.185 1.185 0 0 0 1.185 1.186h6.52a1.185 1.185 0 0 0 1.186-1.186V2.371a1.185 1.185 0 0 0-1.186-1.186h-6.52Z"
    />
  </svg>
);

export default CopyIcon;
